var map = {
	"./Cindy_Cooper": 414,
	"./Cindy_Cooper.jpg": 414,
	"./Graham_Wheeler": 415,
	"./Graham_Wheeler.jpg": 415,
	"./Laura_Flight": 416,
	"./Laura_Flight.jpg": 416,
	"./Mike_Bradburn": 417,
	"./Mike_Bradburn.jpg": 417,
	"./Munya_Dimairo": 418,
	"./Munya_Dimairo.jpg": 418,
	"./NIHR_logo": 419,
	"./NIHR_logo.svg": 419,
	"./Philip_Pallmann": 420,
	"./Philip_Pallmann.jpg": 420,
	"./Thomas_Jaki": 421,
	"./Thomas_Jaki.jpg": 421,
	"./cambridge_logo_2": 422,
	"./cambridge_logo_2.png": 422,
	"./cardiff_ctr": 423,
	"./cardiff_ctr.jpg": 423,
	"./lancaster_uni": 424,
	"./lancaster_uni.svg": 424,
	"./panda-letter-logo": 425,
	"./panda-letter-logo.png": 425,
	"./panda-logo": 426,
	"./panda-logo.png": 426,
	"./plasma": 427,
	"./plasma.jpg": 427,
	"./purple_coral": 428,
	"./purple_coral.jpg": 428,
	"./sheffield_ctru": 429,
	"./sheffield_ctru.png": 429,
	"./ucl_ctc": 430,
	"./ucl_ctc.jpg": 430,
	"./uos-crest": 431,
	"./uos-crest.svg": 431
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;